angular.module("vgresiduos").controller("OrganizationsPermissionGroupListCtrl", [
	"$stateParams",
	"$rootScope",
	function ($stateParams, $rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "organizacao/perfis-acesso");
		};
	}
]);
